/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BedConflictOccupant } from './BedConflictOccupant';
import {
    BedConflictOccupantFromJSON,
    BedConflictOccupantFromJSONTyped,
    BedConflictOccupantToJSON,
    BedConflictOccupantToJSONTyped,
} from './BedConflictOccupant';

/**
 * An outstanding bed conflict (an other-lead occupancy) that must be resolved before the Undo Move-Out can apply; null when the event was applied.
 * @export
 * @interface ResolveIntegrationEventResponseData
 */
export interface ResolveIntegrationEventResponseData {
    /**
     * The ActionConfirmation for the outstanding conflict (e.g. 'bed_conflict').
     */
    confirmation?: string;
    /**
     * 
     */
    occupant?: BedConflictOccupant;
}

/**
 * Check if a given object implements the ResolveIntegrationEventResponseData interface.
 */
export function instanceOfResolveIntegrationEventResponseData(value: object): value is ResolveIntegrationEventResponseData {
    return true;
}

export function ResolveIntegrationEventResponseDataFromJSON(json: any): ResolveIntegrationEventResponseData {
    return ResolveIntegrationEventResponseDataFromJSONTyped(json, false);
}

export function ResolveIntegrationEventResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolveIntegrationEventResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'confirmation': json['confirmation'] == null ? undefined : json['confirmation'],
        'occupant': json['occupant'] == null ? undefined : BedConflictOccupantFromJSON(json['occupant']),
    };
}

export function ResolveIntegrationEventResponseDataToJSON(json: any): ResolveIntegrationEventResponseData {
    return ResolveIntegrationEventResponseDataToJSONTyped(json, false);
}

export function ResolveIntegrationEventResponseDataToJSONTyped(value?: ResolveIntegrationEventResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'confirmation': value['confirmation'],
        'occupant': BedConflictOccupantToJSON(value['occupant']),
    };
}

